import { render } from "./ResourceHubView.vue?vue&type=template&id=c4f4de8c&scoped=true"
import script from "./ResourceHubView.vue?vue&type=script&lang=js"
export * from "./ResourceHubView.vue?vue&type=script&lang=js"

import "./ResourceHubView.vue?vue&type=style&index=0&id=c4f4de8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f4de8c"]])

export default __exports__